import styled from 'styled-components';

import { Button } from '@components/button';
import { IconReplace } from '@components/icons/replace';
import { Stack } from '@components/stack';
import { Text } from '@components/text';
import { theme } from '@styles/theme';
import { pxToRem } from '@utils/converters';

import { AIModel } from 'api/types';

import { getModelLabel, getModelProviderName, PROVIDER_ICONS } from './ai-agent-config';

type AIModelSelectorProps = {
  model: AIModel;
  onOpen?(): void;
};

export const AIModelSelector = ({ model, onOpen }: AIModelSelectorProps) => {
  const provider = getModelProviderName(model);
  const modelLabel = getModelLabel(model);
  const Icon = PROVIDER_ICONS[provider];

  return (
    <ModelSelectorCard>
      <Stack orientation="horizontal" justify="space-between" align="center">
        <Stack orientation="horizontal" align="center" space={3}>
          <Icon size={24} color="iconNeutral" />
          <div>
            <Text font="semibold14" text={provider} />
            <Text font="regular14" color="textSecondary" text={modelLabel} />
          </div>
        </Stack>
        {onOpen && <Button variant="ghost" size="sm" iconLeft={<IconReplace />} onClick={onOpen} />}
      </Stack>
    </ModelSelectorCard>
  );
};

const ModelSelectorCard = styled.div({
  border: `${pxToRem(1)} solid ${theme.color.border20}`,
  borderRadius: pxToRem(8),
  backgroundColor: theme.color.backgroundLightDark,
  padding: `${pxToRem(10)} ${pxToRem(12)}`,
});
